import { render, staticRenderFns } from "./MapPermalinksModal.vue?vue&type=template&id=5058605a"
import script from "./MapPermalinksModal.vue?vue&type=script&lang=js"
export * from "./MapPermalinksModal.vue?vue&type=script&lang=js"
import style0 from "./MapPermalinksModal.vue?vue&type=style&index=0&id=5058605a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports